export default {
  // 收货信息标签
  recipientName: "收货人姓名",
  contactPhone: "联系手机",
  deliveryAddress: "收货地址",
  quantity: "数量",
  time: "时间",
};
